import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../../ContextProviders/AppContextProvider';
import { StatusIcons } from '../../../../../Iconography';
export const StatusChip = ({ state, label, tooltip }) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    let icon;
    let color;
    switch (state) {
        case 'success':
            color = 'success';
            icon = _jsx(StatusIcons.Success, {});
            break;
        case 'info':
            color = 'default';
            icon = _jsx(StatusIcons.Info, {});
            break;
        case 'pending':
            color = 'info';
            icon = _jsx(StatusIcons.Pending, {});
            break;
        case 'error':
            color = 'warning';
            icon = _jsx(StatusIcons.Error, {});
            break;
        case 'failed':
            color = 'error';
            icon = _jsx(StatusIcons.Failed, {});
            break;
    }
    return (_jsx(Tooltip, { title: tooltip, arrow: true, children: _jsx(Chip, { icon: icon, label: isSmallView ? label.substring(0, 3) : label, color: color, size: "small", sx: {
                letterSpacing: 0,
                color: (t) => (color !== 'default' ? t.palette[color].contrastText : 'inherit'),
            } }) }));
};
